import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { INVITE_FRIENDS } from '../../utils/friendsConstants';
import { t } from '../../utils/friendsUtils';
import { CLEAR_ALERT } from '../../state/friendsActions';
import { useFriendsContext } from '../../state/FriendsContext';
import LinkFacebookButton from '../shared/LinkFacebookButton';

import styles from './LinkFacebookAccount.scss';

/* display connect with FB cta */
const LinkFacebookAccount = ({ requestFriends, authorizationStatus }) => {
  const { state, dispatch, track } = useFriendsContext();
  const { source } = state;
  const isInviteFriends = source === INVITE_FRIENDS;
  const analyticsBySource = isInviteFriends
    ? {
        element: 'connect_with_facebook',
        properties: { current_tab: 'facebook' }
      }
    : {
        element: 'connect_fb',
        properties: {}
      };

  useEffect(() => {
    track({
      ...analyticsBySource,
      action: 'screen_enter',
      properties: {
        ...analyticsBySource.properties,
        authorization_status: authorizationStatus
      }
    });
  }, [analyticsBySource, authorizationStatus, track]);

  const handleClick = () => {
    dispatch({ type: CLEAR_ALERT });
    track({
      ...analyticsBySource,
      action: 'click',
      properties: {
        ...analyticsBySource.properties
      }
    });
    requestFriends();
  };

  return (
    <>
      {isInviteFriends && (
        <>
          <h3 className={styles.headline}>{t('invite_friends.title')}</h3>
          <p>{t('invite_friends.message')}</p>
        </>
      )}
      <LinkFacebookButton onClick={handleClick} fullWidth={!isInviteFriends}>
        {isInviteFriends ? t('invite_friends.button') : t('onboarding.button')}
      </LinkFacebookButton>
    </>
  );
};

LinkFacebookAccount.propTypes = {
  requestFriends: PropTypes.func.isRequired,
  authorizationStatus: PropTypes.string.isRequired
};

export default LinkFacebookAccount;
